import React from 'react';
import { DOCS } from '@/docs';
import { MarkdownView } from './MarkdownView';

/** Mostra, dentro de uma tela, o documento de ajuda de uma rota (src/docs) — fonte única do texto. */
export const DocContent: React.FC<{ rota: string; className?: string }> = ({ rota, className }) => {
  const doc = DOCS.find((d) => d.rota === rota);
  if (!doc) return null;
  // O título (# …) já está no cabeçalho da tela/gaveta.
  const body = doc.body.replace(/^#\s+.*\n+/, '');
  return (
    <div className={className ?? 'card p-5'}>
      <MarkdownView source={body} />
    </div>
  );
};
